import React from "react";
import "./Dashboardheader.css";
import axiosInstance from "../../api/axiosInstance";
import { NavLink } from "react-router-dom";
import { apiurl } from "../../App";
import { withTranslation } from "react-i18next";
import MedicineModal from "./MedicineModal";
import PharmacyEntryMaster from "./PharmacyEntryMaster";
import ShowNotification from "../ShowNotification/ShowNotification";
import Cookies from "js-cookie";
import { initEncryptionSession } from "../../encryptionSession";
import { encryptData, decryptData } from "../Crypto_Helpers/cryptoHelper";
import {
  HiOutlineClipboardList,
  HiOutlineEye,
  HiOutlinePlusCircle,
} from "react-icons/hi";

class TotalPrescription extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      fromDate: "",
      toDate: "",
      tableData: [],
      rawTransactions: [],
      prescriptionopenview: false,
      addopen: false,
      prescriptionEntryData: null,
      medicineList: null,
      pdfData: null,
      isModalOpen: false,
      props_loading: true,
      page: 1,
      rowsPerPage: 25,
      visible: false,
      successmsg: "",
      issuccess: false,
    };
  }

  modelopen = (data, id) => {
    let selected = (this.state.rawTransactions || []).filter(
      (val) => val.prescription_id === id || val.id === id
    );
    if (selected.length > 0 && !selected[0].medicines) {
      selected[0].medicines = [];
    }

    if (data === "add") {
      this.setState({
        addopen: true,
        prescriptionEntryData: selected,
      });
    }
  };

  getBack = () => {
    this.setState({
      addopen: false,
    });
  };

  componentDidMount() {
    this.getTotalPrescription();
  }

  viewmedicineList = (data) => {
    this.setState({
      pdfData: data,
      medicineList: data.p_medicinedetails,
      isModalOpen: true,
    });
  };

  handleCloseModal = () => {
    this.setState({ isModalOpen: false });
  };

  getTotalPrescription = async () => {
    this.setState({ props_loading: true });
    try {
      const aesKey = await initEncryptionSession();
      const pharmId =
        Cookies.get("pharmacy_id") ||
        Cookies.get("vendorId") ||
        localStorage.getItem("pharmacy_id") ||
        0;

      const data = {
        pharmacy_id: Number(pharmId) || 0,
        date: this.state.fromDate || "",
        date_to: this.state.toDate || "",
        doctor_id: 0,
        status: 0,
      };

      let requestPayload = data;
      if (aesKey) {
        try {
          const encrypted = await encryptData(data, aesKey);
          requestPayload = { objects: encrypted };
        } catch (e) {
          requestPayload = data;
        }
      }

      const response = await axiosInstance.post(
        "pharmacy/getPrescriptionInfo",
        requestPayload
      );

      let list = [];
      if (response && response.data) {
        if (Array.isArray(response.data.data)) {
          list = response.data.data;
        } else if (typeof response.data.data === "string" && aesKey) {
          try {
            list = await decryptData(response.data.data, aesKey);
          } catch (e) {
            list = [];
          }
        }
      }

      const sortedList = Array.isArray(list)
        ? [...list].sort((a, b) => {
            const idA = Number(a.prescription_id || a.id || 0);
            const idB = Number(b.prescription_id || b.id || 0);
            return idB - idA;
          })
        : [];

      const tableData = [];
      sortedList.forEach((val) => {
        tableData.push({
          orderId: val.custom_order_id,
          customer: val.customer,
          gender: val.gender,
          customer_phno: val.phone_no,
          doctorName: val.doctor_name,
          status: val.status,
          id: val.prescription_id,
          prescript_date: val.prescript_date || val.appointment_date || "",
          rawItem: val,
        });
      });

      this.setState({
        tableData: tableData,
        rawTransactions: sortedList,
        props_loading: false,
      });
    } catch (err) {
      console.error("getTotalPrescription error:", err);
      this.setState({ props_loading: false });
    }
  };

  render() {
    const { search, tableData, page, rowsPerPage, isModalOpen, props_loading } =
      this.state;

    const searchStr = (search || "").trim().toLowerCase();
    const { fromDate, toDate } = this.state;
    const searchData = tableData.filter((data) => {
      if (fromDate && data.prescript_date) {
        const d = data.prescript_date.split("T")[0];
        if (d < fromDate) return false;
      }
      if (toDate && data.prescript_date) {
        const d = data.prescript_date.split("T")[0];
        if (d > toDate) return false;
      }
      if (!searchStr) return true;
      return (
        (data.orderId && data.orderId.toLowerCase().includes(searchStr)) ||
        (data.customer && data.customer.toLowerCase().includes(searchStr)) ||
        (data.customer_phno &&
          data.customer_phno.toString().toLowerCase().includes(searchStr)) ||
        (data.doctorName &&
          data.doctorName.toLowerCase().includes(searchStr)) ||
        (data.status && data.status.toLowerCase().includes(searchStr))
      );
    });

    const currentPage = page || 1;
    const pageSize = rowsPerPage || 25;
    const totalPages = Math.ceil(searchData.length / pageSize) || 1;
    const paginatedData = searchData.slice(
      (currentPage - 1) * pageSize,
      currentPage * pageSize
    );

    const getPageNumbers = (current, total) => {
      if (total <= 5) return Array.from({ length: total }, (_, i) => i + 1);
      let start = Math.max(1, current - 2);
      let end = Math.min(total, start + 4);
      if (end - start < 4) start = Math.max(1, end - 4);
      const pages = [];
      for (let i = start; i <= end; i++) pages.push(i);
      return pages;
    };

    const pageNumbers = getPageNumbers(currentPage, totalPages);
    const startPage = pageNumbers[0];
    const endPage = pageNumbers[pageNumbers.length - 1];

    if (this.state.addopen) {
      return (
        <PharmacyEntryMaster
          prescriptionEntryData={this.state.prescriptionEntryData}
          getBack={() => this.getBack()}
          getTableData={() => this.getTotalPrescription()}
          handleopenSuccess={(msg, status) =>
            this.setState({ visible: true, successmsg: msg, issuccess: status })
          }
        />
      );
    }

    return (
      <div className="p-4 sm:p-5 max-w-[1600px] mx-auto space-y-4 sm:space-y-5 animate-fadeIn">
        {/* Medicine Detail Modal */}
        {isModalOpen && (
          <MedicineModal
            isModalOpen={isModalOpen}
            data={this.state.medicineList}
            pdfData={this.state.pdfData}
            onClose={this.handleCloseModal}
            tittle="Total Prescription"
          />
        )}

        {/* Top Header Card */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 bg-white p-3.5 sm:p-4 rounded-xl border border-gray-100 shadow-2xs">
          <div className="flex items-center gap-3">
            <NavLink
              to="/Home/dashboard"
              className="w-8 h-8 rounded-lg bg-teal-50 hover:bg-teal-600 text-teal-700 hover:text-white flex items-center justify-center transition-all duration-300 shadow-2xs active:scale-95 group"
              title="Back to Dashboard"
            >
              <svg
                className="w-4 h-4 stroke-[2.5] transform group-hover:-translate-x-0.5 transition-transform"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 19l-7-7 7-7"
                />
              </svg>
            </NavLink>
            <div>
              <div className="flex items-center gap-2">
                <h1 className="text-base sm:text-lg font-bold text-gray-900 tracking-tight">
                  Total <span className="text-teal-600">Prescriptions</span>
                </h1>
                <span className="px-2 py-0.5 rounded-full bg-teal-50 text-teal-700 text-[10px] font-bold border border-teal-100">
                  {searchData.length}{" "}
                  {searchData.length === 1 ? "record" : "records"}
                </span>
              </div>
              <p className="text-xs text-gray-500 font-medium mt-0.5">
                Complete archive of patient prescription orders and dispensing
                history
              </p>
            </div>
          </div>

          {/* Search and Date Filter Controls */}
          <div className="flex flex-col sm:flex-row flex-wrap sm:items-center gap-2.5 w-full sm:w-auto">
            <div className="flex flex-wrap items-center gap-1.5 bg-gray-50/80 p-1 rounded-xl border border-gray-200 w-full sm:w-auto">
              <div className="flex items-center gap-1 px-1.5">
                <span className="text-[10px] font-bold text-gray-500 uppercase">From:</span>
                <input
                  type="date"
                  value={this.state.fromDate}
                  onChange={(e) => this.setState({ fromDate: e.target.value }, () => this.getTotalPrescription())}
                  className="bg-white px-1.5 py-1 rounded-lg border border-gray-200 text-xs font-semibold text-gray-700 outline-none focus:border-teal-500"
                />
              </div>
              <div className="flex items-center gap-1 px-1.5">
                <span className="text-[10px] font-bold text-gray-500 uppercase">To:</span>
                <input
                  type="date"
                  value={this.state.toDate}
                  onChange={(e) => this.setState({ toDate: e.target.value }, () => this.getTotalPrescription())}
                  className="bg-white px-1.5 py-1 rounded-lg border border-gray-200 text-xs font-semibold text-gray-700 outline-none focus:border-teal-500"
                />
              </div>
              <button
                type="button"
                onClick={this.getTotalPrescription}
                className="px-2.5 py-1 bg-teal-600 hover:bg-teal-700 text-white rounded-lg text-xs font-bold transition-all shadow-2xs cursor-pointer"
              >
                Filter
              </button>
              {(this.state.fromDate || this.state.toDate) && (
                <button
                  type="button"
                  onClick={() => {
                    this.setState({ fromDate: "", toDate: "" }, () => this.getTotalPrescription());
                  }}
                  className="px-2 py-1 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg text-xs font-bold transition-all cursor-pointer"
                >
                  Reset
                </button>
              )}
            </div>

            {/* Search Box */}
            <div className="relative w-full sm:w-auto min-w-[200px]">
              <input
                type="text"
                placeholder="Search by patient, ID, doctor..."
                value={search}
                onChange={(e) =>
                  this.setState({ search: e.target.value, page: 1 })
                }
                className="w-full pl-9 pr-3 py-1.5 rounded-lg border border-gray-300 bg-gray-50/50 focus:border-teal-600 focus:bg-white text-xs font-medium outline-none transition-all"
              />
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
                <svg
                  className="w-3.5 h-3.5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>

        {/* Table Container Card */}
        <div className="bg-white rounded-xl border border-gray-100 shadow-2xs overflow-hidden flex flex-col">
          <div className="overflow-x-auto w-full">
            <table className="w-full text-left border-collapse min-w-[950px]">
              <thead>
                <tr className="bg-slate-50/90 border-b border-gray-200 text-xs font-bold text-slate-700 uppercase tracking-wider select-none">
                  <th className="py-2.5 px-3 text-center w-12 shrink-0">S.No</th>
                  <th className="py-2.5 px-3 text-center w-36 whitespace-nowrap">
                    Prescription ID
                  </th>
                  <th className="py-2.5 px-4 text-left min-w-[180px] whitespace-nowrap">
                    Patient Name
                  </th>
                  <th className="py-2.5 px-3 text-center w-24 whitespace-nowrap">Gender</th>
                  <th className="py-2.5 px-3 text-center w-36 whitespace-nowrap">Phone No</th>
                  <th className="py-2.5 px-4 text-left min-w-[200px] whitespace-nowrap">
                    Prescribed By
                  </th>
                  <th className="py-2.5 px-3 text-center w-32 whitespace-nowrap">Medicines</th>
                  <th className="py-2.5 px-3 text-center w-28 whitespace-nowrap">Status</th>
                  <th className="py-2.5 px-3 text-center w-36 whitespace-nowrap">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100 text-xs sm:text-sm">
                {props_loading ? (
                  <tr>
                    <td
                      colSpan={9}
                      className="py-12 text-center text-gray-400 font-medium"
                    >
                      <div className="flex flex-col items-center justify-center gap-2">
                        <div className="w-6 h-6 border-2 border-teal-600 border-t-transparent rounded-full animate-spin" />
                        <p className="text-xs font-bold text-slate-500 uppercase tracking-wider">
                          Loading prescriptions archive...
                        </p>
                      </div>
                    </td>
                  </tr>
                ) : paginatedData.length === 0 ? (
                  <tr>
                    <td
                      colSpan={9}
                      className="py-12 text-center text-gray-400 font-medium"
                    >
                      <div className="flex flex-col items-center justify-center gap-1.5">
                        <div className="w-10 h-10 rounded-xl bg-gray-50 flex items-center justify-center text-gray-300 text-xl">
                          📋
                        </div>
                        <p className="text-sm font-bold text-slate-700">
                          No prescriptions found
                        </p>
                        <p className="text-xs text-slate-400">
                          {search
                            ? "No records match your search criteria"
                            : "No prescription records available"}
                        </p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  paginatedData.map((data, index) => {
                    const rowNumber = (currentPage - 1) * pageSize + index + 1;
                    const statusStr = (data.status || '').toLowerCase().trim();
                    const isCanceled = statusStr.includes("cancel");
                    const isDeliveredOrCompleted = statusStr.includes("deliver") || statusStr.includes("complete");
                    const hideQuoteBtn = isCanceled || isDeliveredOrCompleted;
                    return (
                      <tr
                        key={data.id || index}
                        className="hover:bg-teal-50/20 transition-colors group"
                      >
                        {/* S.No */}
                        <td className="py-2.5 px-3 text-center text-xs font-bold text-slate-500">
                          {rowNumber}
                        </td>

                        {/* Prescription ID */}
                        <td className="py-2.5 px-3 text-center">
                          <span className="px-2.5 py-1 rounded-lg bg-teal-50 text-teal-800 font-mono text-xs font-bold border border-teal-100">
                            #{data.orderId}
                          </span>
                        </td>

                        {/* Patient Name */}
                        <td className="py-2.5 px-4 text-left font-bold text-slate-900 text-xs sm:text-sm">
                          {data.customer || "Walk-in Patient"}
                        </td>

                        {/* Gender */}
                        <td className="py-2.5 px-3 text-center">
                          <span className="px-2 py-0.5 rounded-md bg-slate-100 text-slate-800 text-xs font-bold uppercase">
                            {data.gender || "-"}
                          </span>
                        </td>

                        {/* Phone No */}
                        <td className="py-2.5 px-3 text-center text-xs font-semibold text-slate-700 font-mono">
                          {data.customer_phno || "-"}
                        </td>

                        {/* Prescribed By */}
                        <td className="py-2.5 px-4 text-left">
                          <div className="flex items-center gap-2">
                            <div className="w-6.5 h-6.5 rounded-full bg-teal-100/70 text-teal-800 flex items-center justify-center text-xs font-bold shrink-0">
                              {(data.doctorName || "D")[0]}
                            </div>
                            <span className="font-bold text-slate-900 text-xs">
                              {data.doctorName || "Direct Pharmacy Entry"}
                            </span>
                          </div>
                        </td>

                        {/* Medicines View */}
                        <td className="py-2.5 px-3 text-center">
                          <button
                            type="button"
                            onClick={() => this.viewmedicineList(data.rawItem)}
                            className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg bg-teal-50 hover:bg-teal-600 text-teal-700 hover:text-white text-xs font-bold transition-all cursor-pointer shadow-2xs active:scale-95"
                          >
                            <HiOutlineEye size={15} />
                            <span>View List</span>
                          </button>
                        </td>

                        {/* Status */}
                        <td className="py-2.5 px-3 text-center text-xs">
                          <span
                            className={`px-2.5 py-1 rounded-full text-xs font-bold inline-flex items-center justify-center gap-1.5 ${
                              isCanceled
                                ? "bg-red-50 text-red-700 border border-red-200"
                                : "bg-emerald-50 text-emerald-700 border border-emerald-200"
                            }`}
                          >
                            <span
                              className={`w-1.5 h-1.5 rounded-full ${
                                isCanceled
                                  ? "bg-red-500"
                                  : "bg-emerald-500"
                              }`}
                            />
                            {data.status || "Completed"}
                          </span>
                        </td>

                        {/* Action / Send Quote */}
                        <td className="py-2.5 px-3 text-center text-xs">
                          {hideQuoteBtn ? (
                            <span className="text-xs text-gray-400 font-medium">-</span>
                          ) : (
                            <button
                              type="button"
                              onClick={() => this.modelopen("add", data.id)}
                              className="inline-flex items-center gap-1.5 px-3 py-1 rounded-lg bg-teal-600 hover:bg-teal-700 text-white text-xs font-bold transition-all cursor-pointer shadow-sm shadow-teal-600/20 active:scale-95 whitespace-nowrap"
                              title="Create & Send Medicine Quote to Patient"
                            >
                              <HiOutlinePlusCircle size={15} />
                              <span>Send Quote</span>
                            </button>
                          )}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          {/* Modern Orderly Pagination Footer */}
          {searchData.length > 0 && (
            <div className="flex flex-col md:flex-row items-center justify-between gap-3 px-4 sm:px-6 py-3.5 border-t border-gray-100 bg-slate-50/50 text-xs sm:text-sm">
              <div className="flex flex-wrap items-center justify-center sm:justify-start gap-3 text-slate-600 font-medium">
                <span className="whitespace-nowrap">
                  Showing{" "}
                  <span className="font-bold text-slate-900">
                    {(currentPage - 1) * pageSize + 1}
                  </span>{" "}
                  to{" "}
                  <span className="font-bold text-slate-900">
                    {Math.min(currentPage * pageSize, searchData.length)}
                  </span>{" "}
                  of{" "}
                  <span className="font-bold text-slate-900">
                    {searchData.length}
                  </span>{" "}
                  prescriptions
                </span>
                <div className="flex items-center gap-1.5 ml-2 whitespace-nowrap">
                  <span className="font-semibold text-slate-700">Rows:</span>
                  <select
                    value={pageSize}
                    onChange={(e) =>
                      this.setState({
                        rowsPerPage: Number(e.target.value),
                        page: 1,
                      })
                    }
                    className="px-2 py-1 bg-white border border-gray-200 rounded-lg text-xs font-bold text-slate-700 outline-none cursor-pointer focus:border-teal-500"
                  >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </select>
                </div>
              </div>

              {/* Page navigation buttons */}
              <div className="flex items-center gap-1 sm:gap-1.5 flex-wrap justify-center">
                <button
                  type="button"
                  disabled={currentPage === 1}
                  onClick={() => this.setState({ page: currentPage - 1 })}
                  className={`px-3 py-1.5 rounded-lg text-xs font-bold transition-all ${
                    currentPage === 1
                      ? "text-slate-300 bg-transparent cursor-not-allowed border border-transparent"
                      : "text-slate-700 bg-white hover:bg-teal-50 hover:text-teal-700 border border-gray-200 cursor-pointer shadow-2xs"
                  }`}
                >
                  Previous
                </button>

                {startPage > 1 && (
                  <>
                    <button
                      type="button"
                      onClick={() => this.setState({ page: 1 })}
                      className="w-8 h-8 rounded-lg text-xs font-bold transition-all cursor-pointer bg-white text-slate-700 hover:bg-slate-100 border border-gray-200"
                    >
                      1
                    </button>
                    {startPage > 2 && <span className="text-slate-400 text-xs px-0.5 select-none">...</span>}
                  </>
                )}

                {pageNumbers.map((pageNum) => (
                  <button
                    key={pageNum}
                    type="button"
                    onClick={() => this.setState({ page: pageNum })}
                    className={`w-8 h-8 rounded-lg text-xs font-bold transition-all cursor-pointer ${
                      currentPage === pageNum
                        ? "bg-teal-600 text-white shadow-xs shadow-teal-600/30"
                        : "bg-white text-slate-700 hover:bg-slate-100 border border-gray-200"
                    }`}
                  >
                    {pageNum}
                  </button>
                ))}

                {endPage < totalPages && (
                  <>
                    {endPage < totalPages - 1 && <span className="text-slate-400 text-xs px-0.5 select-none">...</span>}
                    <button
                      type="button"
                      onClick={() => this.setState({ page: totalPages })}
                      className="w-8 h-8 rounded-lg text-xs font-bold transition-all cursor-pointer bg-white text-slate-700 hover:bg-slate-100 border border-gray-200"
                    >
                      {totalPages}
                    </button>
                  </>
                )}

                <button
                  type="button"
                  disabled={currentPage === totalPages}
                  onClick={() => this.setState({ page: currentPage + 1 })}
                  className={`px-3 py-1.5 rounded-lg text-xs font-bold transition-all ${
                    currentPage === totalPages
                      ? "text-slate-300 bg-transparent cursor-not-allowed border border-transparent"
                      : "text-slate-700 bg-white hover:bg-teal-50 hover:text-teal-700 border border-gray-200 cursor-pointer shadow-2xs"
                  }`}
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </div>
        <ShowNotification
          visible={this.state.visible}
          successmsg={this.state.successmsg}
          issuccess={this.state.issuccess}
          handleCloseSuccess={() => this.setState({ visible: false })}
        />
      </div>
    );
  }
}

export default withTranslation()(TotalPrescription);
